import { render, staticRenderFns } from "./CertificadosDigitais.vue?vue&type=template&id=144c4651&scoped=true&"
import script from "./CertificadosDigitais.vue?vue&type=script&lang=js&"
export * from "./CertificadosDigitais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c4651",
  null
  
)

export default component.exports